import * as React from 'react';

const SvgSearch: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width={23}
      height={24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.097 14h.757l4.782 5-1.428 1.49-4.791-4.99v-.79l-.26-.28A6.053 6.053 0 019.105 16c-3.44 0-6.229-2.91-6.229-6.5S5.664 3 9.105 3c3.44 0 6.228 2.91 6.228 6.5 0 1.61-.565 3.09-1.504 4.23l.268.27zM4.792 9.5c0 2.49 1.926 4.5 4.312 4.5s4.313-2.01 4.313-4.5S11.49 5 9.104 5C6.718 5 4.792 7.01 4.792 9.5z"
        fill="currentColor"
      />
    </svg>
  );
};

export default SvgSearch;
